import { render } from "./LoginWithPhone.vue?vue&type=template&id=0023745b&scoped=true"
import script from "./LoginWithPhone.vue?vue&type=script&lang=js"
export * from "./LoginWithPhone.vue?vue&type=script&lang=js"

import "./LoginWithPhone.vue?vue&type=style&index=0&id=0023745b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0023745b"]])

export default __exports__